export function isChampionshipCompetition(comp) {
  if (!comp) return false;
  if (comp.isChampionship === true) return true;
  const name = String(comp.name || comp.competitionName || '').toLowerCase();
  return /\bchampionships?\b/.test(name);
}
